import CampaignWizard from 'features/co-pilot/campaign-wizard/campaign-wizard';
import { Navigate, useParams } from 'react-router';
import { NavigationStates } from 'stores/app-bar-navigation-store';

import CampaignPageController from './campaign-page-controller';
import CoPilotTabPage from './co-pilot-tab-page';
import ProjectsPageController from './projects-page-controller';

export const CoPilotProjectsPage = () => <ProjectsPageController />;
export const CoPilotCampaignPage = () => <CampaignPageController />;
/** Wizard „Neue Kampagne“ (nur Recruiting). `new-campaign/:campaignId` nimmt einen Entwurf wieder auf. */
export const CoPilotNewCampaignPage = () => <CampaignWizard />;

/**
 * Legacy redirect for `.../co-pilot/campaign/:campaignId`.
 *
 * That URL used to render the campaign BUILDER, which takes its campaign from the `?_id=`
 * query parameter. Handed a path segment instead it found none, concluded there was
 * nothing to load, and started a brand new campaign — which is what the "Details" button
 * in the campaign list did to everyone who pressed it. The detail view lives on the
 * projects page (the component that reads `useParams().campaignId`), so old links go
 * there rather than breaking.
 */
export const CoPilotCampaignDetailRedirect = () => {
  const { campaignId } = useParams();
  return <Navigate to={`../projects/${campaignId ?? ''}`} replace />;
};
export const CoPilotAccountsPage = () => <CoPilotTabPage tab={NavigationStates.LINKEDIN_ACCOUNT_MANAGEMENT} />;
export const CoPilotBlacklistPage = () => <CoPilotTabPage tab={NavigationStates.BLACKLIST} />;
export const CoPilotStatisticsPage = () => <CoPilotTabPage tab={NavigationStates.STATISTICS} />;
export const CoPilotInboxPage = () => <CoPilotTabPage tab={NavigationStates.INBOX} />;
export const CoPilotTasksPage = () => <CoPilotTabPage tab={NavigationStates.TASK_MANAGER} />;
